<script lang="ts">
    import {Input, Label} from "flowbite-svelte";

    export let value;

    export let label = null;
    export let id = 'input-' + (Math.random() + 1).toString(36).substring(2)
</script>
{#if label}
    <Label for={id}>{label}</Label>
{/if}
<Input {id} type="number" bind:value />
